// extracted by mini-css-extract-plugin
export var alertIcon = "_pr-0";